import { Button, DataSource, HorizontalSpacer, Image, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutPayeeTotals extends Layout {
    buttonRecurringDetail: Button;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    imageExpand: Image;
    imageNeedsReview: Image;
    label401kCatchUp: Label;
    label401kCatchUpAmount: Label;
    label401kContribution: Label;
    label401kContributionAmount: Label;
    labelAdjustment: Label;
    labelAdjustmentDeductions: Label;
    labelAdjustmentTotal: Label;
    labelCityWithholding: Label;
    labelCityWithholdingAmount: Label;
    labelCountyWithholding: Label;
    labelCountyWithholdingAmount: Label;
    labelFedWithholding: Label;
    labelFedWithholdingAmount: Label;
    labelGrossPay: Label;
    labelGrossPayAmount: Label;
    labelLiabilityInsurance: Label;
    labelLiabilityInsuranceAmount: Label;
    labelMedicare: Label;
    labelMedicareAmount: Label;
    labelNetPay: Label;
    labelOtherAdjustments: Label;
    labelOtherPayrollTax: Label;
    labelOtherPayrollTaxAmount: Label;
    labelP: Label;
    labelPFML: Label;
    labelPFMLAmount: Label;
    labelPayeeId: Label;
    labelPreviousAmountOwedTitle: Label;
    labelRecurringPayAdjustments: Label;
    labelRefresh: Label;
    labelRoth401kCatchUp: Label;
    labelRoth401kCatchUpAmount: Label;
    labelRoth401kContribution: Label;
    labelRoth401kContributionAmount: Label;
    labelSettlement: Label;
    labelSettlementTotal: Label;
    labelSocialSecurity: Label;
    labelSocialSecurityAmount: Label;
    labelStateDisability: Label;
    labelStateDisabilityAmount: Label;
    labelStateUnemployment: Label;
    labelStateUnemploymentAmount: Label;
    labelStateWithholding: Label;
    labelStateWithholdingAmount: Label;
    labelSummary: Label;
    labelTimeCard: Label;
    labelTimeCardTotal: Label;
    labelTotalNetPay: Label;
    labelTrailerRent: Label;
    labelTrailerRentAmount: Label;
    labelViewTimecard: Label;
    labelW: Label;
    labelWithholdingTotal: Label;
    labelWithholdings: Label;
    labelWithholdingsTotal: Label;
    labelWithholdingsTotalTitle: Label;
    labelWorkersCompensation: Label;
    labelWorkersCompensationAmount: Label;
    panel401kCatchUp: Panel;
    panel401kContribution: Panel;
    panelAdjustment: Panel;
    panelCityWithholding: Panel;
    panelContent: Panel;
    panelCountyWithholding: Panel;
    panelDriverTotals: Panel;
    panelFederalWithholding: Panel;
    panelGrossPayTotal: Panel;
    panelHeader: Panel;
    panelLiabilityInsurance: Panel;
    panelMedicare: Panel;
    panelNetPay: Panel;
    panelOtherAdjustments: Panel;
    panelOtherPayrollTax: Panel;
    panelPFML: Panel;
    panelPreviousAmountOwed: Panel;
    panelRecurrings: Panel;
    panelRoth401kCatchUp: Panel;
    panelRoth401kContribution: Panel;
    panelSettlement: Panel;
    panelSocialSecurity: Panel;
    panelStateDisability: Panel;
    panelStateUnemployment: Panel;
    panelStateWithholding: Panel;
    panelTimecard: Panel;
    panelTotalNetPay: Panel;
    panelTrailerRent: Panel;
    panelWithholdingItems: Panel;
    panelWithholdings: Panel;
    panelWithholdingsTotal: Panel;
    panelWithholdingsTotalNet: Panel;
    panelWorkersCompensation: Panel;
    sourcePayeeTotals: DataSource;
}
